import { invokePortalLambda } from './portalLambda';

/**
 * Runs one named operation in a client's AWS account through the client
 * access Lambda (TASK-625). The browser holds no credentials for any client
 * account: the Lambda checks the person's sign-in, reads the client's account
 * from its config, and limits the session to that one operation.
 */
export function clientAccess<T>(action: string, payload: Record<string, unknown>): Promise<T> {
  return invokePortalLambda<T>('CLIENT_ACCESS_LAMBDA', { action, ...payload });
}
